export const DollyLinkoutExperimentName = 'ms_dollylinkout';

export enum DollyLinkoutVariations {
  CONTROL = 'control',
  VARIANT = 'variant',
}
